import { useNavigate } from "react-router-dom";

// Material-UI
import { Fab, Grid, Paper, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";

// Components
import { DataGrid, EditButton, FabContainer, ViewButton } from '@arredo/reactjs-ui';
import StockControlFilters from "./filters";

// Hooks
import useStockControls from "../../hooks/stockControls/useStockControls";
import useAuthorize from '../../hooks/user/useAuthorize';

// Other
import useStyles from './styles'

// Models
import { stockControlStates, title, columns } from "../../models/StockControlEntity";
import { Permissions } from '../../models/Roles';

const StockControls = () => {
    const isAuthorized = useAuthorize();
    const { classes } = useStyles();
    const push = useNavigate()
    const { stockControls, loading, totalPage, setParameterSearch, filters, clearFilters } = useStockControls();

    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });

    return (
        <>
            <Grid size="grow">
                <Paper className={classes.paper}>
                    <Typography variant="h4">
                        {title}
                    </Typography>
                </Paper>
            </Grid>
            <StockControlFilters filters={filters} setFilters={setParameterSearch} clearFilters={clearFilters} />
            <DataGrid
                columns={columns}
                rows={stockControls}
                loading={loading}
                actions={
                    ({ row }) => (
                        <>
                            {isAuthorized([Permissions.AuditorView]) && (
                                <ViewButton
                                    to={`/stockControls/${row.id}`}
                                />)
                            }

                            {isAuthorized([Permissions.AuditorEdit]) && isAuthorized([Permissions.AuditorEdit]) && row.state === stockControlStates.created &&
                                (
                                    <EditButton to={`/stockControls/update/${row.id}`} />
                                )
                            }

                        </>
                    )
                }
                paginationProps={{
                    count: totalPage,
                    page: filters?.pageNumber || 1,
                    onChange: handleChangePage
                }}
            />
            {isAuthorized([Permissions.AuditorCreate]) &&
                <FabContainer>
                    <Fab
                        color='primary'
                        variant="extended"
                        className={classes.fab}
                        onClick={() => push('/stockControls/create')}
                    >
                        <Add className={classes.extendedIcon} />
                        Crear
                    </Fab>
                </FabContainer>}
        </>
    );
}

export default StockControls;